import { ControlledSelectInput2 } from 'Components';
import { AdvancedSearchContext } from 'Context/MedicalReferralsContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useContext } from 'react';
import { getMedicalReferralStatusName } from 'Utils/getMedicalReferralStatus';

export const ReferralState = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.MedicalReferrals)
    .search.advancedSearch;
  const { advancedSearch, dispatchAdvancedSearch } = useContext(
    AdvancedSearchContext
  );

  const isDesktop = useIsDesktop();

  const { approved, review, denied, opened, cancelled } = dictionary.options;

  return (
    <ControlledSelectInput2
      disablePortal={isDesktop ? false : true}
      size={'small'}
      label={dictionary.accordingToRequestState}
      value={getMedicalReferralStatusName(
        advancedSearch.requestState,
        dictionary.options
      )}
      options={[opened, approved, review, denied, cancelled]}
      onChange={(e) => {
        dispatchAdvancedSearch({
          type: 'REQUEST_STATE',
          payload: { value: e.target.value, options: dictionary.options },
        });
      }}
    />
  );
};
